var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRteOrderedList = function SvgRteOrderedList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m3.168 4.168 1-1v3.667m0 0h-1m1 0h.667m4 2.666H7.772a.6.6 0 0 1-.5-.928.4.4 0 0 1 .124-.116l1.2-.798a.5.5 0 0 0 .125-.116.667.667 0 0 0-.551-1.042H7.168m4 3.334h.964c.823 0 .97 1.258.21 1.47a.5.5 0 0 1-.114.016l-.393.014.393.013a.5.5 0 0 1 .113.016c.76.212.614 1.47-.209 1.47h-.964"
  })));
};
export default SvgRteOrderedList;